import { IconProps } from "../../../types/style";

const PasswordEyes = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.75 9.15018C19.44 5.52017 16.06 3.43018 12.5 3.43018C10.72 3.43018 8.99 3.95018 7.41 4.92018C5.83 5.90018 4.41 7.33017 3.25 9.15018C2.25 10.7202 2.25 13.2702 3.25 14.8402C5.56 18.4802 8.94 20.5602 12.5 20.5602C14.28 20.5602 16.01 20.0402 17.59 19.0702C19.17 18.0902 20.59 16.6602 21.75 14.8402C22.75 13.2802 22.75 10.7202 21.75 9.15018ZM12.5 16.0402C10.26 16.0402 8.46 14.2302 8.46 12.0002C8.46 9.77018 10.26 7.96018 12.5 7.96018C14.74 7.96018 16.54 9.77018 16.54 12.0002C16.54 14.2302 14.74 16.0402 12.5 16.0402Z"
          fill={color}
        />
        <path
          d="M12.4999 9.14014C10.9299 9.14014 9.6499 10.4201 9.6499 12.0001C9.6499 13.5701 10.9299 14.8501 12.4999 14.8501C14.0699 14.8501 15.3599 13.5701 15.3599 12.0001C15.3599 10.4301 14.0699 9.14014 12.4999 9.14014Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default PasswordEyes;
